export const loader = () => '<span class="loader"></span>';

export const quoteLoader = () => '<span class="quote-loader"></span>';
